import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 50px;
  padding-left: 10%;
  padding-right: 10%;
`

const Member = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Name = styled.p`
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000;
`
const Position = styled.p`
  font-size: 18px;
`
const MembersSection = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "gatsby-astronaut.png" }) {
        childImageSharp {
          fixed(width: 300, height: 300) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      icon: file(relativePath: { eq: "gatsby-icon.png" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      mohammad: file(relativePath: { eq: "Mohammad6.jpeg" }) {
        childImageSharp {
          fixed(width: 120, height: 120, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      stella: file(relativePath: { eq: "Stella5.png" }) {
        childImageSharp {
          fixed(width: 120, height: 120, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      joe: file(relativePath: { eq: "Joe.jpg" }) {
        childImageSharp {
          fixed(width: 120, height: 120, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      youmin: file(relativePath: { eq: "Youmin.jpg" }) {
        childImageSharp {
          fixed(width: 120, height: 120, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  return (
    <Container>
      <Member>
        <Img
          style={{ borderRadius: "100%" }}
          fixed={data.mohammad.childImageSharp.fixed}
        />
        <Name>Mohammad Baqer</Name>
        <Position>UX Designer</Position>
      </Member>
      <Member>
        <Img
          style={{ borderRadius: "100%" }}
          fixed={data.stella.childImageSharp.fixed}
        />
        <Name>Sooyoung Park</Name>
        <Position>UX Designer</Position>
      </Member>
      <Member>
        <Img
          style={{ borderRadius: "100%" }}
          fixed={data.joe.childImageSharp.fixed}
        />
        <Name>Dr. Joseph Hollingsworth</Name>
        <Position>Advisor</Position>
      </Member>
      <Member>
        <Img
          style={{ borderRadius: "100%" }}
          fixed={data.youmin.childImageSharp.fixed}
        />
        <Name>Youmin Park</Name>
        <Position>Graphic Designer</Position>
      </Member>
    </Container>
  )
}

export default MembersSection
